import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import RestorePassword from '@/views/RestorePassword.vue'
import PageNotFound from '@/components/PageNotFound.vue'
import api from '@/api';
import errorHandler from '../error.handler';


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/logout',
    name: 'Logout',
    beforeEnter: async (to, from, next) => {
      if (localStorage.getItem('AUTH_TOKEN')) {
        try {
          await api.logout();
        } catch (err) {
          errorHandler.logErrors(err);
        } finally {
          localStorage.removeItem('AUTH_TOKEN');
        }
      }
      next('/');
    },
  },
  {
    path: "/forgot-password",
    name: "forgotPassword",
    component: RestorePassword
  },
  {
    path: '*',
    name: '404',
    component: PageNotFound
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router
